export default __webpack_public_path__ + "static/media/eco.dd7df847.png";